import React from 'react';
import GeoWorkspace from '../shared/GeoWorkspace.jsx';
export default function FDCGeoWorkspace(props) { return <GeoWorkspace role="FDC" {...props}/>; }
